export default "__VITE_ASSET__DPp3lmLC__"